import React, { FunctionComponent } from "react";
import { BodyCard, RegularPrice } from "../../theme/theme";
import CornerRibbon from "react-corner-ribbon";
import AddFrom from '../AddFrom';
import CurrencyFormat from '../../utils/currencyFormat'
import { CardContent, ProductCardName, ProductCardImage, ProductCardImageContainer, ProductPrice } from "./style";
import {calculatePriceWithTax, returnProduct} from '../../utils/formatData'

type ProductType = {
    id: number;
    title: string;
    netAmount: number;
    amount: number;
    discountPrice: number;
    discountRate: number;
    img: string[];
    categories?: number;
};

type ProductCardType = {
    isOnModal?: boolean;
    product: ProductType;
    minWidth?: string;
    imageContainerWidth?: string;
    handleRedirectProductInfo: (
        id: number,
        category?: number
    ) => void | ((id: number) => void);
};

const ProductCard: FunctionComponent<ProductCardType> = ({
    product,
    handleRedirectProductInfo,
    minWidth,
    isOnModal
}) => {

    return (
        <CardContent minWidth={minWidth} secondImage={(product.img.length >1 && product.img[1].length > 29) ? product.img[1] : product.img[0]}
            onClick={() => {
                if (product.categories)
                    handleRedirectProductInfo(product.id, product.categories);
                else handleRedirectProductInfo(product.id);
            }}
        >
            <ProductCardImageContainer>
                <ProductCardImage
                    width={isOnModal ? '20vh': '37vh'}
                    alt={product.title}
                    src={product.img[0]}
                />
                {product.discountRate > 0 && <CornerRibbon backgroundColor="#ff0000" fontColor="#f0f0f0" containerStyle={{}}>
                    <AddFrom product={product} field={"discountRate"} fontSize=".6rem" fontWeight="600" br={true} />
                    <span style={{fontFamily: 'Roboto', fontWeight: 700, fontSize: '1rem'}}>
                        {' '+returnProduct(product, 'discountRate')}%off
                    </span>
                </CornerRibbon> }
            </ProductCardImageContainer>
            <BodyCard>
                <ProductCardName text={product.title} />
                {product.discountRate > 0 ? (
                    <>
                        <RegularPrice>
                        <AddFrom product={product} fontSize=".9rem"/> <CurrencyFormat amount={product.netAmount ? calculatePriceWithTax(product) : returnProduct(product, 'amount')}/>
                        </RegularPrice>
                        <ProductPrice>
                            <AddFrom product={product} fontSize="1rem"/> <CurrencyFormat amount={returnProduct(product, 'amount')}/>
                        </ProductPrice>
                    </>
                ) : (
                    <ProductPrice>
                        <AddFrom product={product} fontSize="1rem"/> <CurrencyFormat amount={returnProduct(product, 'amount')}/>
                    </ProductPrice>
                )}
            </BodyCard>
        </CardContent>
    );
};

export default ProductCard;
